import React from 'react';
import { ModalParts } from 'pages/redux';
import ActivityLogsDraftSearch from './ActivityLogsDraftSearch';
import ActivityLogsTableFilters from './ActivityLogsTableFilters';
import * as CardS from './ActivitySearch.styled';

type ActivityLogsSearchControlsProps = {
  setModal: (modal: ModalParts | null) => void,
  /** Results bar vs Search activity card. */
  layout: 'bar' | 'card',
  widePane?: boolean,
};

/** Draft search + Time / + / − / Cash — shown next to New search or in Search activity. */
const ActivityLogsSearchControls = ({
  setModal,
  layout,
  widePane,
}: ActivityLogsSearchControlsProps) => {
  if (layout === 'bar') {
    return (
      <CardS.ResultsControls>
        <ActivityLogsDraftSearch barLayout />
        <ActivityLogsTableFilters setModal={setModal} inline widePane={widePane} />
      </CardS.ResultsControls>
    );
  }

  return (
    <CardS.CardControls>
      <CardS.CardControlsRow>
        <ActivityLogsDraftSearch inline />
        <ActivityLogsTableFilters setModal={setModal} inline widePane={widePane} />
      </CardS.CardControlsRow>
    </CardS.CardControls>
  );
};

export default ActivityLogsSearchControls;
